import EducatorRegister from './EducatorRegister'
export default EducatorRegister;